export enum JourneyType {
  TELECONSULTATION = 'TELECONSULTATION',
  PHYSICAL_TRANSPORT = 'PHYSICAL_TRANSPORT',
  BYPASS = 'BYPASS',
}
